export default __webpack_public_path__ + "static/media/flag-basque-country.28ecf659.svg";